import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class InventoryTransfers_ds_inventory_transfer_lines_gridService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { inventoryTransferId: number }): 
  Promise<{ result: { Id?: number, AllowInactiveInventory?: boolean, ErrorMessage?: string, SourcePackageAmount?: number, SourceMaterial?: { Id?: number, LookupCode?: string }, SourceVendorLot?: { Id?: number, LookupCode?: string }, SourceLot?: { Id?: number, LookupCode?: string }, SourcePackage?: { Id?: number, ShortName?: string }, SourceLicensePlate?: { Id?: number, LookupCode?: string }, SourceSerialNumber?: { Id?: number, LookupCode?: string }, TargetMaterial?: { Id?: number, LookupCode?: string }, Warehouse?: { Id?: number, Name?: string }, Status?: { Id?: number, Name?: string } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.inventoryTransferId)) {
      missingRequiredInParams.push('\'inventoryTransferId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/InventoryTransfers/datasources/ds_inventory_transfer_lines_grid/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { inventoryTransferId: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, AllowInactiveInventory?: boolean, ErrorMessage?: string, SourcePackageAmount?: number, SourceMaterial?: { Id?: number, LookupCode?: string }, SourceVendorLot?: { Id?: number, LookupCode?: string }, SourceLot?: { Id?: number, LookupCode?: string }, SourcePackage?: { Id?: number, ShortName?: string }, SourceLicensePlate?: { Id?: number, LookupCode?: string }, SourceSerialNumber?: { Id?: number, LookupCode?: string }, TargetMaterial?: { Id?: number, LookupCode?: string }, Warehouse?: { Id?: number, Name?: string }, Status?: { Id?: number, Name?: string } }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.inventoryTransferId)) {
      missingRequiredInParams.push('\'inventoryTransferId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/InventoryTransfers/datasources/ds_inventory_transfer_lines_grid/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { inventoryTransferId: number, $keys: number[] }): 
  Promise<{ result: { Id?: number, AllowInactiveInventory?: boolean, ErrorMessage?: string, SourcePackageAmount?: number, SourceMaterial?: { Id?: number, LookupCode?: string }, SourceVendorLot?: { Id?: number, LookupCode?: string }, SourceLot?: { Id?: number, LookupCode?: string }, SourcePackage?: { Id?: number, ShortName?: string }, SourceLicensePlate?: { Id?: number, LookupCode?: string }, SourceSerialNumber?: { Id?: number, LookupCode?: string }, TargetMaterial?: { Id?: number, LookupCode?: string }, Warehouse?: { Id?: number, Name?: string }, Status?: { Id?: number, Name?: string } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.inventoryTransferId)) {
      missingRequiredInParams.push('\'inventoryTransferId\'');
    }
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/InventoryTransfers/datasources/ds_inventory_transfer_lines_grid/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      inventoryTransferId: number    }) {
        if(isNil(inParams.inventoryTransferId)) {
          return true; 
        }
      return false;
    }
}
